import React from 'react';
import { Button } from 'app/components';
import { CmtyCard } from '../components';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useLoginModal from '../../login/useLoginModal';

const Cmty = () => {

  const navigate = useNavigate();
  const loginModal = useLoginModal();
  const { userData } = useSelector((state) => state.app);

  const handleClick = () => {
    const phoneNumber = '9025082101';
    const message = "I'm very interested in your ticketing platform and would love to discuss it further.";
    const desktopUrl = `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
    const mobileUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
    const isMobile = window.innerWidth < 650; // For mobile, width less than 1024px

    const url = '/event/create';
    if (!userData?.email) {
      loginModal.onOpen();
      loginModal.callback.current = () => navigate(url);
    } else {
      navigate(url);
    }
  };

  const onCreateEventClick = () => {
    if (!userData?.email) {
      loginModal.onOpen();  
      loginModal.callback.current = () => navigate('/event/create');
    } else {
      navigate('/event/create');
    }
  };

  const CmtyData = [
    {
      img:'/assets/images/cmt1.png',
      content:'Manage your attendees in one place'
    },
    {
      img:'assets/images/cmt2.png',
      content:'Share announcements & updates directly',
    },
    {
      img:'assets/images/cmt3.png',
      content:'Keep your audience engaged',
    }
  ]
  return (
    <div className='flex flex-col max-w-5xl m-auto h-auto md:h-screen items-center justify-center  py-10 px-5 md:px-0 md:py-16 gap-16 '>
      <div className='flex flex-row justify-between items-center'> 
       <div className=" heading-36 md:text-[60px] font-bold  text-black md:leading-tight text-center md:text-left">Create and manage <span className='text-primary '> Communities </span>effortlessly</div>
       <img 
              src="/assets/images/mng.jpg"
            className="w-[150px] h-[150px] md:inline hidden"
              alt="Ticket Icon"
          />  
      </div>
            <div className='flex flex-col md:flex-row gap-4'> 
              {CmtyData.map((stepItem, index) => (
                <CmtyCard
                  key={index}
                  imgSrc={stepItem.img}
                  content={stepItem.content}
                />
              ))}
              </div>
              <div className='hero-button'>
        <Button type="primary-black" rounded="true"     
        onClick={handleClick} 
        > 
         <div className='label-16'>List your event</div>
    
        </Button>
        </div>
    </div>
  )
}

export default Cmty;
